  <footer id="footer" class="footer fixed-bottom footer-dark navbar-border navbar-shadow navbar-light bg-light">
    <p class="clearfix text-sm-center mb-0 px-2 black">
      <span class="float-md-left d-block d-md-inline-block black">Copyright &copy; 2023 
        <b><a class="" href="https://portalweb.utpuebla.edu.mx/" target="_blank">Universidad Tecnológica de Puebla</a></b>
      </span>
      <span class="float-md-left d-block d-md-inline-block black"> | División de Tecnologías de la Información</span>
      <span class="float-md-right d-block d-md-inline-block d-none d-lg-block black">84 &amp; 67<i class="feather ft-heart pink"></i>
        <span id="scroll-top"></span>
      </span>
    </p>
  </footer>
  <!--   -->
  